import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'row'];

  mark(event) {
    event.preventDefault();

    const confirmMessage = event.currentTarget.dataset.confirm;
    if (confirmMessage && !window.confirm(confirmMessage)) return;

    if (this.hasInputTarget) {
      this.inputTarget.disabled = false;
    }

    if (this.hasRowTarget) {
      this.rowTarget.classList.add('document-marked-for-removal');
    }

    event.currentTarget.disabled = true;
    event.currentTarget.setAttribute('aria-disabled', 'true');
  }
}
